import { render, staticRenderFns } from "./ResetPasswordSms.vue?vue&type=template&id=303cd461&"
import script from "./ResetPasswordSms.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordSms.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordSms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports